<template>
  <div class="py-16 bg-gray-50">



    <!-- 商品列表 -->
    <div class="container mx-auto px-6 mb-14">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Application Scenarios</h2>
        <p class="text-gray-600 max-w-2xl mx-auto">
          From smart production lines to supply chain management, explore real-world use cases where our product
          delivers targeted value
        </p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="bg-white p-3 rounded-lg shadow-md flex flex-col items-center"  v-for="item in data" :key="item.id">
          <div class="w-full h-48 mb-4 overflow-hidden rounded">
            <img :src="item.photoOssUrl" alt="ISO 9001 Certification"
              class="w-full h-full object-cover transition-transform hover:scale-105 duration-300">
          </div>
          <h3 class="font-semibold text-gray-800">{{ item.name }}</h3>
        </div>
        
      </div>
    </div>
    <Pagination :current-page="pageNum" :total="total" :page-size="pageSize" @page-change="handlePageChange" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue';
import { pageApplicationScene } from '@/api/applicationScene'
const pageNum = ref(1)
const data = ref([])
const total = ref(0)
const pageSize = ref(12)
onMounted(() => {
  getPageApplicationScene()
})
const getPageApplicationScene = async () => {
  let res = await pageApplicationScene({
    pageNum: pageNum.value,
    pageSize: pageSize.value
  })
  data.value = res.rows
  total.value = res.total
}
// 处理页码变更
const handlePageChange = (newPage) => {
  pageNum.value = newPage;
  getPageApplicationScene()
};

</script>

<style scoped>
.product-card {
  transition: all 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.text-primary {
  color: #3b82f6;
}
</style>